import React, { useState, useEffect } from "react";

import ReactPay from "features/payment";
import ClientStats from "shared/util/ClientStats";
import OkcApi from "shared/util/OkcApi";
import _str from "shared/util/_str";
import Masthead from "./Masthead";

import "./BillingWoes.scss";

const BillingWoes = React.forwardRef((_, ref) => {
	// Fetch the billing failure info.
	const [failure, setFailure] = useState(null);
	useEffect(() => {
		OkcApi.get("billingws/failures")
			.then((res) => setFailure(res.failure));
	}, []);

	useEffect(() => {
		if (!failure) {
			return;
		}

		ClientStats.update(`failed billing - banner impressions - product:${failure.feature}`);
	}, [failure]);

	// Don't render if no failures found.
	if (!failure) {
		return null;
	}

	// Handle clicking renew.
	const openPaymentsModal = () => ReactPay.openEditor();

	return (
		<Masthead ref={ref} id="alist_billing_woes" className="billingwoes" noClose>
			<div className="text">
				<h3>{_str("Update your subscription!")}</h3>
				<p>
					{failure.description}
				</p>
			</div>
			<div className="button">
				<button onClick={openPaymentsModal} className="big green flatbutton">
					{_str("Renew Subscription")}
				</button>
			</div>
		</Masthead>
	);
});

export default BillingWoes;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/BillingWoes.jsx